/* tslint:disable */
/* eslint-disable */
/**
 * 
 * @export
 * @interface AddBotMessageRequest
 */
export interface AddBotMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof AddBotMessageRequest
     */
    botMessage: string;
}
/**
 * 
 * @export
 * @interface AutotraderAccessTokenResponse
 */
export interface AutotraderAccessTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof AutotraderAccessTokenResponse
     */
    access_token?: string;
}
/**
 * 
 * @export
 * @interface AutotraderVehicleDataConfigurationDTO
 */
export interface AutotraderVehicleDataConfigurationDTO extends VehicleDataConfigurationDTO {
    /**
     * 
     * @type {string}
     * @memberof AutotraderVehicleDataConfigurationDTO
     */
    advertiserId: string;
}


/**
 * 
 * @export
 * @interface BookedCallBackChatEventDTO
 */
export interface BookedCallBackChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {ChatEventDTO}
     * @memberof BookedCallBackChatEventDTO
     */
    associated_check_chat_event?: ChatEventDTO;
    /**
     * 
     * @type {string}
     * @memberof BookedCallBackChatEventDTO
     */
    booking_datetime?: string;
}


/**
 * 
 * @export
 * @interface BookedEmailFollowUpChatEventDTO
 */
export interface BookedEmailFollowUpChatEventDTO extends ChatEventDTO {
}


/**
 * 
 * @export
 * @interface BookedTestDriveChatEventDTO
 */
export interface BookedTestDriveChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {ChatEventDTO}
     * @memberof BookedTestDriveChatEventDTO
     */
    associated_check_chat_event?: ChatEventDTO;
    /**
     * 
     * @type {string}
     * @memberof BookedTestDriveChatEventDTO
     */
    booking_datetime?: string;
    /**
     * 
     * @type {string}
     * @memberof BookedTestDriveChatEventDTO
     */
    test_drive_vin?: string;
    /**
     * 
     * @type {string}
     * @memberof BookedTestDriveChatEventDTO
     */
    test_drive_vrm?: string;
}


/**
 * 
 * @export
 * @interface BotDTO
 */
export interface BotDTO {
    /**
     * 
     * @type {number}
     * @memberof BotDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BotDTO
     */
    publicId?: string;
    /**
     * 
     * @type {string}
     * @memberof BotDTO
     */
    siteName?: string;
    /**
     * 
     * @type {string}
     * @memberof BotDTO
     */
    siteURL?: string;
    /**
     * 
     * @type {BotType}
     * @memberof BotDTO
     */
    botType?: BotType;
    /**
     * 
     * @type {boolean}
     * @memberof BotDTO
     */
    isReimportFinished?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BotDTO
     */
    conversationLimit?: number;
    /**
     * 
     * @type {string}
     * @memberof BotDTO
     */
    lastRenewalDate?: string;
    /**
     * 
     * @type {number}
     * @memberof BotDTO
     */
    workingRange?: number;
    /**
     * 
     * @type {RedirectProvider}
     * @memberof BotDTO
     */
    redirectProvider?: RedirectProvider;
    /**
     * 
     * @type {UrlProcessorConfigurationDTO}
     * @memberof BotDTO
     */
    urlProcessorConfiguration?: UrlProcessorConfigurationDTO;
    /**
     * 
     * @type {string}
     * @memberof BotDTO
     */
    knowledge?: string;
    /**
     * 
     * @type {string}
     * @memberof BotDTO
     */
    teamInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof BotDTO
     */
    openAiApiKey?: string;
    /**
     * 
     * @type {SupportedTimezone}
     * @memberof BotDTO
     */
    timezone?: SupportedTimezone;
    /**
     * 
     * @type {Array<LocationDTO>}
     * @memberof BotDTO
     */
    locationList?: Array<LocationDTO>;
    /**
     * 
     * @type {EmailConfigurationDTO}
     * @memberof BotDTO
     */
    emailConfiguration?: EmailConfigurationDTO;
    /**
     * 
     * @type {FinanceConfigurationDTO}
     * @memberof BotDTO
     */
    financeConfiguration?: FinanceConfigurationDTO;
    /**
     * 
     * @type {ValuationConfigurationDTO}
     * @memberof BotDTO
     */
    valuationConfiguration?: ValuationConfigurationDTO;
    /**
     * 
     * @type {ToolSettingsDTO}
     * @memberof BotDTO
     */
    toolSettings?: ToolSettingsDTO;
    /**
     * 
     * @type {ReservationConfigurationDTO}
     * @memberof BotDTO
     */
    reservationConfiguration?: ReservationConfigurationDTO;
}


/**
 * 
 * @export
 * @interface BotInListDTO
 */
export interface BotInListDTO {
    /**
     * 
     * @type {string}
     * @memberof BotInListDTO
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof BotInListDTO
     */
    siteName: string;
    /**
     * 
     * @type {string}
     * @memberof BotInListDTO
     */
    siteURL: string;
    /**
     * 
     * @type {number}
     * @memberof BotInListDTO
     */
    conversationCountAllTime: number;
    /**
     * 
     * @type {number}
     * @memberof BotInListDTO
     */
    conversationCountLastRenewalDate: number;
    /**
     * 
     * @type {number}
     * @memberof BotInListDTO
     */
    usedConversationPercentage: number;
}

/**
 * 
 * @export
 */
export const BotType = {
    AimeStarter: 'AIME_STARTER',
    AimeStock: 'AIME_STOCK',
    AimePx: 'AIME_PX',
    AimeFinance: 'AIME_FINANCE',
    AimeReservation: 'AIME_RESERVATION',
    TmcAime: 'TMC_AIME',
    CazooAime: 'CAZOO_AIME',
    AimeBuy: 'AIME_BUY'
} as const;
export type BotType = typeof BotType[keyof typeof BotType];

/**
 * 
 * @export
 * @interface ChatEventDTO
 */
export interface ChatEventDTO {
    /**
     * 
     * @type {number}
     * @memberof ChatEventDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ChatEventDTO
     */
    event_type?: ChatEventDTOEventTypeEnum;
}


/**
 * @export
 */
export const ChatEventDTOEventTypeEnum = {
    ReturnedLocationInformation: 'RETURNED_LOCATION_INFORMATION',
    ReturnedCompanyInformation: 'RETURNED_COMPANY_INFORMATION',
    ReturnedCompanyWorkingHours: 'RETURNED_COMPANY_WORKING_HOURS',
    ReturnedJourneyDetails: 'RETURNED_JOURNEY_DETAILS',
    CheckedTestDriveBookingAvailability: 'CHECKED_TEST_DRIVE_BOOKING_AVAILABILITY',
    CheckedCallBackBookingAvailability: 'CHECKED_CALL_BACK_BOOKING_AVAILABILITY',
    BookedCallBack: 'BOOKED_CALL_BACK',
    BookedEmailFollowUp: 'BOOKED_EMAIL_FOLLOW_UP',
    BookedTestDrive: 'BOOKED_TEST_DRIVE',
    ReturnedVehicleInformation: 'RETURNED_VEHICLE_INFORMATION',
    ReturnedVehicleValuation: 'RETURNED_VEHICLE_VALUATION',
    ReturnedFinanceIllustration: 'RETURNED_FINANCE_ILLUSTRATION',
    ReturnedFinanceQuote: 'RETURNED_FINANCE_QUOTE',
    ReturnedFinanceApplication: 'RETURNED_FINANCE_APPLICATION',
    ReturnedStripeForm: 'RETURNED_STRIPE_FORM',
    ReservedVehicle: 'RESERVED_VEHICLE',
    RequestedLimitedVehicleInformation: 'REQUESTED_LIMITED_VEHICLE_INFORMATION',
    RequestedLimitedFinanceIllustration: 'REQUESTED_LIMITED_FINANCE_ILLUSTRATION',
    RequestedLimitedVehicleValuation: 'REQUESTED_LIMITED_VEHICLE_VALUATION',
    RequestedLimitedVehicleReservation: 'REQUESTED_LIMITED_VEHICLE_RESERVATION'
} as const;
export type ChatEventDTOEventTypeEnum = typeof ChatEventDTOEventTypeEnum[keyof typeof ChatEventDTOEventTypeEnum];

/**
 * 
 * @export
 * @interface CheckedCallBackBookingAvailabilityChatEventDTO
 */
export interface CheckedCallBackBookingAvailabilityChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckedCallBackBookingAvailabilityChatEventDTO
     */
    checked_date?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckedCallBackBookingAvailabilityChatEventDTO
     */
    checked_time?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckedCallBackBookingAvailabilityChatEventDTO
     */
    check_status?: CheckedCallBackBookingAvailabilityChatEventDTOCheckStatusEnum;
}


/**
 * @export
 */
export const CheckedCallBackBookingAvailabilityChatEventDTOCheckStatusEnum = {
    Available: 'AVAILABLE',
    TooLate: 'TOO_LATE',
    TooEarly: 'TOO_EARLY',
    OutOfWorkingHours: 'OUT_OF_WORKING_HOURS',
    Closed: 'CLOSED',
    Past: 'PAST',
    NoSuitableTimeIn7Days: 'NO_SUITABLE_TIME_IN_7_DAYS'
} as const;
export type CheckedCallBackBookingAvailabilityChatEventDTOCheckStatusEnum = typeof CheckedCallBackBookingAvailabilityChatEventDTOCheckStatusEnum[keyof typeof CheckedCallBackBookingAvailabilityChatEventDTOCheckStatusEnum];

/**
 * 
 * @export
 * @interface CheckedTestDriveBookingAvailabilityChatEventDTO
 */
export interface CheckedTestDriveBookingAvailabilityChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckedTestDriveBookingAvailabilityChatEventDTO
     */
    checked_date?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckedTestDriveBookingAvailabilityChatEventDTO
     */
    checked_time?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckedTestDriveBookingAvailabilityChatEventDTO
     */
    check_status?: CheckedTestDriveBookingAvailabilityChatEventDTOCheckStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CheckedTestDriveBookingAvailabilityChatEventDTO
     */
    preferred_test_drive_vin?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckedTestDriveBookingAvailabilityChatEventDTO
     */
    preferred_test_drive_vrm?: string;
}


/**
 * @export
 */
export const CheckedTestDriveBookingAvailabilityChatEventDTOCheckStatusEnum = {
    Available: 'AVAILABLE',
    TooLate: 'TOO_LATE',
    TooEarly: 'TOO_EARLY',
    OutOfWorkingHours: 'OUT_OF_WORKING_HOURS',
    Closed: 'CLOSED',
    Past: 'PAST',
    NoSuitableTimeIn7Days: 'NO_SUITABLE_TIME_IN_7_DAYS'
} as const;
export type CheckedTestDriveBookingAvailabilityChatEventDTOCheckStatusEnum = typeof CheckedTestDriveBookingAvailabilityChatEventDTOCheckStatusEnum[keyof typeof CheckedTestDriveBookingAvailabilityChatEventDTOCheckStatusEnum];


/**
 * 
 * @export
 */
export const ClickAction = {
    SendMessage: 'SEND_MESSAGE',
    RedirectToDetailsPage: 'REDIRECT_TO_DETAILS_PAGE'
} as const;
export type ClickAction = typeof ClickAction[keyof typeof ClickAction];

/**
 * 
 * @export
 * @interface ConditionMultipliersDTO
 */
export interface ConditionMultipliersDTO {
    /**
     * 
     * @type {number}
     * @memberof ConditionMultipliersDTO
     */
    id?: number;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof ConditionMultipliersDTO
     */
    excellentSubtraction?: SubtractionDTO;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof ConditionMultipliersDTO
     */
    goodSubtraction?: SubtractionDTO;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof ConditionMultipliersDTO
     */
    averageSubtraction?: SubtractionDTO;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof ConditionMultipliersDTO
     */
    belowAverageSubtraction?: SubtractionDTO;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof ConditionMultipliersDTO
     */
    poorSubtraction?: SubtractionDTO;
}
/**
 * 
 * @export
 * @interface ConditionMultipliersUi
 */
export interface ConditionMultipliersUi {
    /**
     * 
     * @type {number}
     * @memberof ConditionMultipliersUi
     */
    id: number;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof ConditionMultipliersUi
     */
    excellentSubtraction: SubtractionUi;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof ConditionMultipliersUi
     */
    goodSubtraction: SubtractionUi;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof ConditionMultipliersUi
     */
    averageSubtraction: SubtractionUi;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof ConditionMultipliersUi
     */
    belowAverageSubtraction: SubtractionUi;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof ConditionMultipliersUi
     */
    poorSubtraction: SubtractionUi;
}

/**
 * 
 * @export
 */
export const ConvoStarterVisibility = {
    Bubble: 'BUBBLE',
    Chat: 'CHAT'
} as const;
export type ConvoStarterVisibility = typeof ConvoStarterVisibility[keyof typeof ConvoStarterVisibility];

/**
 * 
 * @export
 * @interface CreateBotRequest
 */
export interface CreateBotRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    publicId: string;
    /**
     * 
     * @type {BotType}
     * @memberof CreateBotRequest
     */
    botType: BotType;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBotRequest
     */
    isReimportFinished?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    siteName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    siteURL: string;
    /**
     * 
     * @type {number}
     * @memberof CreateBotRequest
     */
    conversationLimit: number;
    /**
     * 
     * @type {number}
     * @memberof CreateBotRequest
     */
    workingRange?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    lastRenewalDate: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    knowledge: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    teamInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    openAiApiKey?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBotRequest
     */
    publicLocationIdList: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    assistantEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    assistantEmailPassword?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBotRequest
     */
    emailTranscriptRecipients: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBotRequest
     */
    filtrationEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    financeIddUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateBotRequest
     */
    financeInterestRate?: number;
    /**
     * 
     * @type {Array<CreateRetailPriceRuleRequest>}
     * @memberof CreateBotRequest
     */
    retailPriceRules: Array<CreateRetailPriceRuleRequest>;
    /**
     * 
     * @type {CreateConditionMultipliersRequest}
     * @memberof CreateBotRequest
     */
    conditionMultipliers: CreateConditionMultipliersRequest;
    /**
     * 
     * @type {CreateServiceHistoryMultipliersRequest}
     * @memberof CreateBotRequest
     */
    serviceHistoryMultipliers: CreateServiceHistoryMultipliersRequest;
    /**
     * 
     * @type {number}
     * @memberof CreateBotRequest
     */
    minDeduction: number;
    /**
     * 
     * @type {number}
     * @memberof CreateBotRequest
     */
    maxDeduction: number;
    /**
     * 
     * @type {RedirectProvider}
     * @memberof CreateBotRequest
     */
    redirectProvider: RedirectProvider;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBotRequest
     */
    urlProcessorEnabled: boolean;
    /**
     * 
     * @type {MatchField}
     * @memberof CreateBotRequest
     */
    matchField?: MatchField;
    /**
     * 
     * @type {MatchType}
     * @memberof CreateBotRequest
     */
    matchType?: MatchType;
    /**
     * 
     * @type {number}
     * @memberof CreateBotRequest
     */
    segmentNumberFromTheEnd?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBotRequest
     */
    testDriveBookingEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    stripePublicKey?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    stripeSecretKey?: string;
    /**
     * 
     * @type {Currency}
     * @memberof CreateBotRequest
     */
    currency?: Currency;
    /**
     * 
     * @type {number}
     * @memberof CreateBotRequest
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    timezone?: CreateBotRequestTimezoneEnum;
}


/**
 * @export
 */
export const CreateBotRequestTimezoneEnum = {
    EuropeLondon: 'EUROPE_LONDON'
} as const;
export type CreateBotRequestTimezoneEnum = typeof CreateBotRequestTimezoneEnum[keyof typeof CreateBotRequestTimezoneEnum];

/**
 * 
 * @export
 * @interface CreateConditionMultipliersRequest
 */
export interface CreateConditionMultipliersRequest {
    /**
     * 
     * @type {CreateSubtractionRequest}
     * @memberof CreateConditionMultipliersRequest
     */
    excellentSubtraction: CreateSubtractionRequest;
    /**
     * 
     * @type {CreateSubtractionRequest}
     * @memberof CreateConditionMultipliersRequest
     */
    goodSubtraction: CreateSubtractionRequest;
    /**
     * 
     * @type {CreateSubtractionRequest}
     * @memberof CreateConditionMultipliersRequest
     */
    averageSubtraction: CreateSubtractionRequest;
    /**
     * 
     * @type {CreateSubtractionRequest}
     * @memberof CreateConditionMultipliersRequest
     */
    belowAverageSubtraction: CreateSubtractionRequest;
    /**
     * 
     * @type {CreateSubtractionRequest}
     * @memberof CreateConditionMultipliersRequest
     */
    poorSubtraction: CreateSubtractionRequest;
}
/**
 * 
 * @export
 * @interface CreateLocationRequest
 */
export interface CreateLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    postcode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    phoneNumber: string;
    /**
     * 
     * @type {CreateWorkScheduleRequest}
     * @memberof CreateLocationRequest
     */
    workSchedule: CreateWorkScheduleRequest;
    /**
     * 
     * @type {VehicleDataProvider}
     * @memberof CreateLocationRequest
     */
    vehicleDataProvider: VehicleDataProvider;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    advertiserId?: string;
}


/**
 * 
 * @export
 * @interface CreateRetailPriceRuleRequest
 */
export interface CreateRetailPriceRuleRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateRetailPriceRuleRequest
     */
    min: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRetailPriceRuleRequest
     */
    max: number;
    /**
     * 
     * @type {CreateSubtractionRequest}
     * @memberof CreateRetailPriceRuleRequest
     */
    subtraction: CreateSubtractionRequest;
}
/**
 * 
 * @export
 * @interface CreateServiceHistoryMultipliersRequest
 */
export interface CreateServiceHistoryMultipliersRequest {
    /**
     * 
     * @type {CreateSubtractionRequest}
     * @memberof CreateServiceHistoryMultipliersRequest
     */
    fullHistorySubtraction: CreateSubtractionRequest;
    /**
     * 
     * @type {CreateSubtractionRequest}
     * @memberof CreateServiceHistoryMultipliersRequest
     */
    partHistorySubtraction: CreateSubtractionRequest;
    /**
     * 
     * @type {CreateSubtractionRequest}
     * @memberof CreateServiceHistoryMultipliersRequest
     */
    noHistorySubtraction: CreateSubtractionRequest;
}
/**
 * 
 * @export
 * @interface CreateStripeIntentRequest
 */
export interface CreateStripeIntentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateStripeIntentRequest
     */
    publicBotId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStripeIntentRequest
     */
    chatId: string;
}
/**
 * 
 * @export
 * @interface CreateSubtractionRequest
 */
export interface CreateSubtractionRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateSubtractionRequest
     */
    subtractionValue: number;
    /**
     * 
     * @type {SubtractionType}
     * @memberof CreateSubtractionRequest
     */
    subtractionType: SubtractionType;
}


/**
 * 
 * @export
 * @interface CreateWorkScheduleRequest
 */
export interface CreateWorkScheduleRequest {
    /**
     * 
     * @type {CreateWorkingHoursRequest}
     * @memberof CreateWorkScheduleRequest
     */
    monday: CreateWorkingHoursRequest;
    /**
     * 
     * @type {CreateWorkingHoursRequest}
     * @memberof CreateWorkScheduleRequest
     */
    tuesday: CreateWorkingHoursRequest;
    /**
     * 
     * @type {CreateWorkingHoursRequest}
     * @memberof CreateWorkScheduleRequest
     */
    wednesday: CreateWorkingHoursRequest;
    /**
     * 
     * @type {CreateWorkingHoursRequest}
     * @memberof CreateWorkScheduleRequest
     */
    thursday: CreateWorkingHoursRequest;
    /**
     * 
     * @type {CreateWorkingHoursRequest}
     * @memberof CreateWorkScheduleRequest
     */
    friday: CreateWorkingHoursRequest;
    /**
     * 
     * @type {CreateWorkingHoursRequest}
     * @memberof CreateWorkScheduleRequest
     */
    saturday: CreateWorkingHoursRequest;
    /**
     * 
     * @type {CreateWorkingHoursRequest}
     * @memberof CreateWorkScheduleRequest
     */
    sunday: CreateWorkingHoursRequest;
}
/**
 * 
 * @export
 * @interface CreateWorkingHoursRequest
 */
export interface CreateWorkingHoursRequest {
    /**
     * 
     * @type {LocalTime}
     * @memberof CreateWorkingHoursRequest
     */
    openTime?: LocalTime;
    /**
     * 
     * @type {LocalTime}
     * @memberof CreateWorkingHoursRequest
     */
    closeTime?: LocalTime;
    /**
     * 
     * @type {boolean}
     * @memberof CreateWorkingHoursRequest
     */
    isClosed: boolean;
}

/**
 * 
 * @export
 */
export const Currency = {
    Pound: 'POUND'
} as const;
export type Currency = typeof Currency[keyof typeof Currency];

/**
 * 
 * @export
 * @interface DefaultWidgetAppearanceSettingUi
 */
export interface DefaultWidgetAppearanceSettingUi {
    /**
     * 
     * @type {string}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    mainColour: string;
    /**
     * 
     * @type {string}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    buttonColour: string;
    /**
     * 
     * @type {WidgetPosition}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    widgetPosition: WidgetPosition;
    /**
     * 
     * @type {number}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    horizontalOffsetPx: number;
    /**
     * 
     * @type {number}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    verticalOffsetPx: number;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    hidePoweredBy: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    promptPopUpView: boolean;
    /**
     * 
     * @type {string}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    defaultPopUpMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    initialBotMessage: string;
    /**
     * 
     * @type {Array<FullConvoStartersUI>}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    convoStarters?: Array<FullConvoStartersUI>;
}


/**
 * 
 * @export
 * @interface EmailConfigurationDTO
 */
export interface EmailConfigurationDTO {
    /**
     * 
     * @type {number}
     * @memberof EmailConfigurationDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof EmailConfigurationDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailConfigurationDTO
     */
    password?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmailConfigurationDTO
     */
    transcriptRecipients?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof EmailConfigurationDTO
     */
    filtrationEnabled?: boolean;
}
/**
 * 
 * @export
 * @interface FinanceConfigurationDTO
 */
export interface FinanceConfigurationDTO {
    /**
     * 
     * @type {number}
     * @memberof FinanceConfigurationDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FinanceConfigurationDTO
     */
    iddUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof FinanceConfigurationDTO
     */
    interestRate?: number;
}
/**
 * 
 * @export
 * @interface FocusedVehicle
 */
export interface FocusedVehicle {
    /**
     * 
     * @type {string}
     * @memberof FocusedVehicle
     */
    vin?: string;
    /**
     * 
     * @type {string}
     * @memberof FocusedVehicle
     */
    vrm?: string;
}
/**
 * 
 * @export
 * @interface FullBotUi
 */
export interface FullBotUi {
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    publicId: string;
    /**
     * 
     * @type {BotType}
     * @memberof FullBotUi
     */
    botType: BotType;
    /**
     * 
     * @type {boolean}
     * @memberof FullBotUi
     */
    isReimportFinished: boolean;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    siteName: string;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    siteURL: string;
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    conversationLimit: number;
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    workingRange?: number;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    knowledge: string;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    teamInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    openAiApiKey?: string;
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    emailConfigurationId: number;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    assistantEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    assistantEmailPassword?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FullBotUi
     */
    emailTranscriptRecipients: Array<string>;
    /**
     * 
     * @type {Array<FullLocationUi>}
     * @memberof FullBotUi
     */
    locationList: Array<FullLocationUi>;
    /**
     * 
     * @type {boolean}
     * @memberof FullBotUi
     */
    filtrationEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    lastRenewalDate: string;
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    financeConfigurationId?: number;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    financeIddUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    financeInterestRate?: number;
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    valuationConfigurationId: number;
    /**
     * 
     * @type {Array<RetailPriceRuleUi>}
     * @memberof FullBotUi
     */
    retailPriceRules: Array<RetailPriceRuleUi>;
    /**
     * 
     * @type {ConditionMultipliersUi}
     * @memberof FullBotUi
     */
    conditionMultipliers: ConditionMultipliersUi;
    /**
     * 
     * @type {ServiceHistoryMultipliersUi}
     * @memberof FullBotUi
     */
    serviceHistoryMultipliers: ServiceHistoryMultipliersUi;
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    minDeduction: number;
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    maxDeduction: number;
    /**
     * 
     * @type {RedirectProvider}
     * @memberof FullBotUi
     */
    redirectProvider: RedirectProvider;
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    urlProcessorConfigurationId: number;
    /**
     * 
     * @type {boolean}
     * @memberof FullBotUi
     */
    urlProcessorEnabled: boolean;
    /**
     * 
     * @type {MatchField}
     * @memberof FullBotUi
     */
    matchField?: MatchField;
    /**
     * 
     * @type {MatchType}
     * @memberof FullBotUi
     */
    matchType?: MatchType;
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    segmentNumberFromTheEnd?: number;
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    reservationConfigurationId: number;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    stripePublicKey?: string;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    stripeSecretKey?: string;
    /**
     * 
     * @type {Currency}
     * @memberof FullBotUi
     */
    currency?: Currency;
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    toolSettingsId: number;
    /**
     * 
     * @type {boolean}
     * @memberof FullBotUi
     */
    testDriveBookingEnabled: boolean;
    /**
     * 
     * @type {SupportedTimezone}
     * @memberof FullBotUi
     */
    timezone: SupportedTimezone;
}


/**
 * 
 * @export
 * @interface FullConvoStartersUI
 */
export interface FullConvoStartersUI {
    /**
     * 
     * @type {number}
     * @memberof FullConvoStartersUI
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FullConvoStartersUI
     */
    message: string;
    /**
     * 
     * @type {ConvoStarterVisibility}
     * @memberof FullConvoStartersUI
     */
    visibility: ConvoStarterVisibility;
}


/**
 * 
 * @export
 * @interface FullLocationUi
 */
export interface FullLocationUi {
    /**
     * 
     * @type {number}
     * @memberof FullLocationUi
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FullLocationUi
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof FullLocationUi
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FullLocationUi
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof FullLocationUi
     */
    postcode: string;
    /**
     * 
     * @type {string}
     * @memberof FullLocationUi
     */
    phoneNumber: string;
    /**
     * 
     * @type {WorkScheduleUi}
     * @memberof FullLocationUi
     */
    workSchedule: WorkScheduleUi;
    /**
     * 
     * @type {VehicleDataProvider}
     * @memberof FullLocationUi
     */
    vehicleDataProvider: VehicleDataProvider;
    /**
     * 
     * @type {string}
     * @memberof FullLocationUi
     */
    advertiserId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FullLocationUi
     */
    canBeDeleted: boolean;
}


/**
 * 
 * @export
 * @interface FullWidgetAppearanceSettingUi
 */
export interface FullWidgetAppearanceSettingUi {
    /**
     * 
     * @type {number}
     * @memberof FullWidgetAppearanceSettingUi
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FullWidgetAppearanceSettingUi
     */
    publicBotId: string;
    /**
     * 
     * @type {string}
     * @memberof FullWidgetAppearanceSettingUi
     */
    mainColour: string;
    /**
     * 
     * @type {string}
     * @memberof FullWidgetAppearanceSettingUi
     */
    buttonColour: string;
    /**
     * 
     * @type {WidgetPosition}
     * @memberof FullWidgetAppearanceSettingUi
     */
    widgetPosition: WidgetPosition;
    /**
     * 
     * @type {number}
     * @memberof FullWidgetAppearanceSettingUi
     */
    horizontalOffsetPx: number;
    /**
     * 
     * @type {number}
     * @memberof FullWidgetAppearanceSettingUi
     */
    verticalOffsetPx: number;
    /**
     * 
     * @type {boolean}
     * @memberof FullWidgetAppearanceSettingUi
     */
    hidePoweredBy: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FullWidgetAppearanceSettingUi
     */
    promptPopUpView: boolean;
    /**
     * 
     * @type {string}
     * @memberof FullWidgetAppearanceSettingUi
     */
    defaultPopUpMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof FullWidgetAppearanceSettingUi
     */
    initialBotMessage: string;
    /**
     * 
     * @type {Array<FullConvoStartersUI>}
     * @memberof FullWidgetAppearanceSettingUi
     */
    convoStarters?: Array<FullConvoStartersUI>;
    /**
     * 
     * @type {Array<VehicleDetailsButtonUi>}
     * @memberof FullWidgetAppearanceSettingUi
     */
    vehicleDetailsButtons?: Array<VehicleDetailsButtonUi>;
}



/**
 * 
 * @export
 */
export const InitializationType = {
    Unsupported: 'UNSUPPORTED',
    OnOpenWidgetEvent: 'ON_OPEN_WIDGET_EVENT',
    OnUrlClick: 'ON_URL_CLICK',
    OnWidgetClick: 'ON_WIDGET_CLICK',
    OnSendingMessageFromModal: 'ON_SENDING_MESSAGE_FROM_MODAL',
    OnButtonClick: 'ON_BUTTON_CLICK'
} as const;
export type InitializationType = typeof InitializationType[keyof typeof InitializationType];


/**
 * 
 * @export
 */
export const InputType = {
    Manual: 'MANUAL',
    Button: 'BUTTON'
} as const;
export type InputType = typeof InputType[keyof typeof InputType];

/**
 * 
 * @export
 * @interface LocalTime
 */
export interface LocalTime {
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    hour?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    minute?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    second?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    nano?: number;
}
/**
 * 
 * @export
 * @interface LocationDTO
 */
export interface LocationDTO {
    /**
     * 
     * @type {number}
     * @memberof LocationDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof LocationDTO
     */
    publicId?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDTO
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDTO
     */
    postcode?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDTO
     */
    phoneNumber?: string;
    /**
     * 
     * @type {WorkScheduleDTO}
     * @memberof LocationDTO
     */
    workSchedule?: WorkScheduleDTO;
    /**
     * 
     * @type {LocationDTOVehicleDataConfiguration}
     * @memberof LocationDTO
     */
    vehicleDataConfiguration?: LocationDTOVehicleDataConfiguration;
}
/**
 * @type LocationDTOVehicleDataConfiguration
 * 
 * @export
 */
export type LocationDTOVehicleDataConfiguration = AutotraderVehicleDataConfigurationDTO | NoProviderVehicleDataConfigurationDTO | TmcAutotraderVehicleDataConfigurationDTO;
/**
 * 
 * @export
 * @interface LocationInListDTO
 */
export interface LocationInListDTO {
    /**
     * 
     * @type {number}
     * @memberof LocationInListDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof LocationInListDTO
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof LocationInListDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LocationInListDTO
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof LocationInListDTO
     */
    postcode: string;
    /**
     * 
     * @type {boolean}
     * @memberof LocationInListDTO
     */
    canBeDeleted: boolean;
    /**
     * 
     * @type {VehicleDataProvider}
     * @memberof LocationInListDTO
     */
    vehicleDataProvider: VehicleDataProvider;
}



/**
 * 
 * @export
 */
export const MatchField = {
    ExternalStockId: 'EXTERNAL_STOCK_ID',
    Derivative: 'DERIVATIVE'
} as const;
export type MatchField = typeof MatchField[keyof typeof MatchField];


/**
 * 
 * @export
 */
export const MatchType = {
    ExactMatch: 'EXACT_MATCH',
    FuzzyMatch: 'FUZZY_MATCH'
} as const;
export type MatchType = typeof MatchType[keyof typeof MatchType];


/**
 * 
 * @export
 */
export const MessageRole = {
    User: 'USER',
    Assistant: 'ASSISTANT',
    Tool: 'TOOL'
} as const;
export type MessageRole = typeof MessageRole[keyof typeof MessageRole];


/**
 * 
 * @export
 */
export const MessageType = {
    Text: 'TEXT',
    Gallery: 'GALLERY',
    Video: 'VIDEO',
    Stripe: 'STRIPE'
} as const;
export type MessageType = typeof MessageType[keyof typeof MessageType];

/**
 * 
 * @export
 * @interface NoProviderVehicleDataConfigurationDTO
 */
export interface NoProviderVehicleDataConfigurationDTO extends VehicleDataConfigurationDTO {
}



/**
 * 
 * @export
 */
export const RedirectProvider = {
    NoRedirect: 'NO_REDIRECT',
    Autotrader: 'AUTOTRADER',
    MotorDesk: 'MOTOR_DESK',
    MotorTech: 'MOTOR_TECH',
    ClickDealer: 'CLICK_DEALER',
    Cazoo: 'CAZOO'
} as const;
export type RedirectProvider = typeof RedirectProvider[keyof typeof RedirectProvider];

/**
 * 
 * @export
 * @interface RequestedLimitedFinanceIllustrationChatEventDTO
 */
export interface RequestedLimitedFinanceIllustrationChatEventDTO extends ChatEventDTO {
}


/**
 * 
 * @export
 * @interface RequestedLimitedVehicleInformationChatEventDTO
 */
export interface RequestedLimitedVehicleInformationChatEventDTO extends ChatEventDTO {
}


/**
 * 
 * @export
 * @interface RequestedLimitedVehicleReservationChatEventDTO
 */
export interface RequestedLimitedVehicleReservationChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof RequestedLimitedVehicleReservationChatEventDTO
     */
    preferred_reservation_vin?: string;
}


/**
 * 
 * @export
 * @interface RequestedLimitedVehicleValuationChatEventDTO
 */
export interface RequestedLimitedVehicleValuationChatEventDTO extends ChatEventDTO {
}


/**
 * 
 * @export
 * @interface ReservationConfigurationDTO
 */
export interface ReservationConfigurationDTO {
    /**
     * 
     * @type {number}
     * @memberof ReservationConfigurationDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ReservationConfigurationDTO
     */
    stripePublicKey?: string;
    /**
     * 
     * @type {string}
     * @memberof ReservationConfigurationDTO
     */
    stripeSecretKey?: string;
    /**
     * 
     * @type {string}
     * @memberof ReservationConfigurationDTO
     */
    currency?: ReservationConfigurationDTOCurrencyEnum;
    /**
     * 
     * @type {number}
     * @memberof ReservationConfigurationDTO
     */
    price?: number;
}


/**
 * @export
 */
export const ReservationConfigurationDTOCurrencyEnum = {
    Pound: 'POUND'
} as const;
export type ReservationConfigurationDTOCurrencyEnum = typeof ReservationConfigurationDTOCurrencyEnum[keyof typeof ReservationConfigurationDTOCurrencyEnum];

/**
 * 
 * @export
 * @interface ReservedVehicleChatEventDTO
 */
export interface ReservedVehicleChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ReservedVehicleChatEventDTO
     */
    reserved_vin?: string;
    /**
     * 
     * @type {string}
     * @memberof ReservedVehicleChatEventDTO
     */
    reserved_vrm?: string;
}


/**
 * 
 * @export
 * @interface RetailPriceRuleDTO
 */
export interface RetailPriceRuleDTO {
    /**
     * 
     * @type {number}
     * @memberof RetailPriceRuleDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RetailPriceRuleDTO
     */
    min?: number;
    /**
     * 
     * @type {number}
     * @memberof RetailPriceRuleDTO
     */
    max?: number;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof RetailPriceRuleDTO
     */
    subtraction?: SubtractionDTO;
}
/**
 * 
 * @export
 * @interface RetailPriceRuleUi
 */
export interface RetailPriceRuleUi {
    /**
     * 
     * @type {number}
     * @memberof RetailPriceRuleUi
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof RetailPriceRuleUi
     */
    min: number;
    /**
     * 
     * @type {number}
     * @memberof RetailPriceRuleUi
     */
    max: number;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof RetailPriceRuleUi
     */
    subtraction: SubtractionUi;
}
/**
 * 
 * @export
 * @interface ReturnedCompanyInformationChatEventDTO
 */
export interface ReturnedCompanyInformationChatEventDTO extends ChatEventDTO {
}


/**
 * 
 * @export
 * @interface ReturnedCompanyWorkingHoursChatEventDTO
 */
export interface ReturnedCompanyWorkingHoursChatEventDTO extends ChatEventDTO {
}


/**
 * 
 * @export
 * @interface ReturnedFinanceApplicationChatEventDTO
 */
export interface ReturnedFinanceApplicationChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    current_home_address?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    previous_home_address?: string;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    number_of_years_spent_at_current_address?: number;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    residential_status?: ReturnedFinanceApplicationChatEventDTOResidentialStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    current_employer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    previous_employer_name?: string;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    number_of_years_spent_with_current_employer?: number;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    driving_licence?: ReturnedFinanceApplicationChatEventDTODrivingLicenceEnum;
}


/**
 * @export
 */
export const ReturnedFinanceApplicationChatEventDTOResidentialStatusEnum = {
    Owner: 'OWNER',
    Tenant: 'TENANT',
    CouncilTenant: 'COUNCIL_TENANT',
    LivingWithParents: 'LIVING_WITH_PARENTS'
} as const;
export type ReturnedFinanceApplicationChatEventDTOResidentialStatusEnum = typeof ReturnedFinanceApplicationChatEventDTOResidentialStatusEnum[keyof typeof ReturnedFinanceApplicationChatEventDTOResidentialStatusEnum];

/**
 * @export
 */
export const ReturnedFinanceApplicationChatEventDTODrivingLicenceEnum = {
    Full: 'FULL',
    Provisional: 'PROVISIONAL',
    None: 'NONE'
} as const;
export type ReturnedFinanceApplicationChatEventDTODrivingLicenceEnum = typeof ReturnedFinanceApplicationChatEventDTODrivingLicenceEnum[keyof typeof ReturnedFinanceApplicationChatEventDTODrivingLicenceEnum];

/**
 * 
 * @export
 * @interface ReturnedFinanceIllustrationChatEventDTO
 */
export interface ReturnedFinanceIllustrationChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceIllustrationChatEventDTO
     */
    finance_vin?: string;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceIllustrationChatEventDTO
     */
    finance_deposit?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceIllustrationChatEventDTO
     */
    finance_term?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceIllustrationChatEventDTO
     */
    vehicle_vat?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceIllustrationChatEventDTO
     */
    full_vehicle_price?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceIllustrationChatEventDTO
     */
    total_deposit?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceIllustrationChatEventDTO
     */
    balance_to_finance?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceIllustrationChatEventDTO
     */
    total_amount_payable?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceIllustrationChatEventDTO
     */
    total_charge_for_credit?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceIllustrationChatEventDTO
     */
    monthly_payment?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceIllustrationChatEventDTO
     */
    interest_rate?: number;
}


/**
 * 
 * @export
 * @interface ReturnedFinanceQuoteChatEventDTO
 */
export interface ReturnedFinanceQuoteChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    finance_vin?: string;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    finance_deposit?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    finance_term?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    vehicle_vat?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    full_vehicle_price?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    total_deposit?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    balance_to_finance?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    total_amount_payable?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    total_charge_for_credit?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    monthly_payment?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    interest_rate?: number;
}


/**
 * 
 * @export
 * @interface ReturnedJourneyDetailsChatEventDTO
 */
export interface ReturnedJourneyDetailsChatEventDTO extends ChatEventDTO {
}


/**
 * 
 * @export
 * @interface ReturnedLocationInformationChatEventDTO
 */
export interface ReturnedLocationInformationChatEventDTO extends ChatEventDTO {
}


/**
 * 
 * @export
 * @interface ReturnedStripeFormChatEventDTO
 */
export interface ReturnedStripeFormChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnedStripeFormChatEventDTO
     */
    preferred_reservation_vin?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedStripeFormChatEventDTO
     */
    preferred_reservation_vrm?: string;
}


/**
 * 
 * @export
 * @interface ReturnedVehicleInformationChatEventDTO
 */
export interface ReturnedVehicleInformationChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnedVehicleInformationChatEventDTO
     */
    generated_sql_query?: string;
    /**
     * 
     * @type {number}
     * @memberof ReturnedVehicleInformationChatEventDTO
     */
    attempts_used?: number;
}


/**
 * 
 * @export
 * @interface ReturnedVehicleValuationChatEventDTO
 */
export interface ReturnedVehicleValuationChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {boolean}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    is_valuated_successfully?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuation_error_message?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vrm?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vehicle_make?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vehicle_model?: string;
    /**
     * 
     * @type {number}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vehicle_mileage?: number;
    /**
     * 
     * @type {string}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vehicle_condition?: ReturnedVehicleValuationChatEventDTOValuatedVehicleConditionEnum;
    /**
     * 
     * @type {string}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vehicle_service_history?: ReturnedVehicleValuationChatEventDTOValuatedVehicleServiceHistoryEnum;
    /**
     * 
     * @type {number}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vehicle_outstanding_finances?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vehicle_gross_cost?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vehicle_net_cost?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vehicle_is_vat_excluded?: boolean;
}


/**
 * @export
 */
export const ReturnedVehicleValuationChatEventDTOValuatedVehicleConditionEnum = {
    Excellent: 'EXCELLENT',
    Good: 'GOOD',
    Average: 'AVERAGE',
    BelowAverage: 'BELOW_AVERAGE',
    Poor: 'POOR'
} as const;
export type ReturnedVehicleValuationChatEventDTOValuatedVehicleConditionEnum = typeof ReturnedVehicleValuationChatEventDTOValuatedVehicleConditionEnum[keyof typeof ReturnedVehicleValuationChatEventDTOValuatedVehicleConditionEnum];

/**
 * @export
 */
export const ReturnedVehicleValuationChatEventDTOValuatedVehicleServiceHistoryEnum = {
    FullHistory: 'FULL_HISTORY',
    PartHistory: 'PART_HISTORY',
    NoHistory: 'NO_HISTORY'
} as const;
export type ReturnedVehicleValuationChatEventDTOValuatedVehicleServiceHistoryEnum = typeof ReturnedVehicleValuationChatEventDTOValuatedVehicleServiceHistoryEnum[keyof typeof ReturnedVehicleValuationChatEventDTOValuatedVehicleServiceHistoryEnum];

/**
 * 
 * @export
 * @interface SaveInitialBotMessageRequest
 */
export interface SaveInitialBotMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveInitialBotMessageRequest
     */
    initialBotMessage: string;
    /**
     * 
     * @type {InitializationType}
     * @memberof SaveInitialBotMessageRequest
     */
    initializationType: InitializationType;
}


/**
 * 
 * @export
 * @interface ServiceHistoryMultipliersDTO
 */
export interface ServiceHistoryMultipliersDTO {
    /**
     * 
     * @type {number}
     * @memberof ServiceHistoryMultipliersDTO
     */
    id?: number;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof ServiceHistoryMultipliersDTO
     */
    fullHistorySubtraction?: SubtractionDTO;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof ServiceHistoryMultipliersDTO
     */
    partHistorySubtraction?: SubtractionDTO;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof ServiceHistoryMultipliersDTO
     */
    noHistorySubtraction?: SubtractionDTO;
}
/**
 * 
 * @export
 * @interface ServiceHistoryMultipliersUi
 */
export interface ServiceHistoryMultipliersUi {
    /**
     * 
     * @type {number}
     * @memberof ServiceHistoryMultipliersUi
     */
    id: number;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof ServiceHistoryMultipliersUi
     */
    fullHistorySubtraction: SubtractionUi;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof ServiceHistoryMultipliersUi
     */
    partHistorySubtraction: SubtractionUi;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof ServiceHistoryMultipliersUi
     */
    noHistorySubtraction: SubtractionUi;
}

/**
 * 
 * @export
 */
export const StripeMessageStatus = {
    NotPaid: 'NOT_PAID',
    Processing: 'PROCESSING',
    PaidNotConfirmed: 'PAID_NOT_CONFIRMED',
    PaidConfirmed: 'PAID_CONFIRMED'
} as const;
export type StripeMessageStatus = typeof StripeMessageStatus[keyof typeof StripeMessageStatus];

/**
 * 
 * @export
 * @interface SubtractionDTO
 */
export interface SubtractionDTO {
    /**
     * 
     * @type {number}
     * @memberof SubtractionDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof SubtractionDTO
     */
    subtractionValue?: number;
    /**
     * 
     * @type {string}
     * @memberof SubtractionDTO
     */
    subtractionType?: SubtractionDTOSubtractionTypeEnum;
}


/**
 * @export
 */
export const SubtractionDTOSubtractionTypeEnum = {
    Percentage: 'PERCENTAGE',
    Number: 'NUMBER'
} as const;
export type SubtractionDTOSubtractionTypeEnum = typeof SubtractionDTOSubtractionTypeEnum[keyof typeof SubtractionDTOSubtractionTypeEnum];


/**
 * 
 * @export
 */
export const SubtractionType = {
    Percentage: 'PERCENTAGE',
    Number: 'NUMBER'
} as const;
export type SubtractionType = typeof SubtractionType[keyof typeof SubtractionType];

/**
 * 
 * @export
 * @interface SubtractionUi
 */
export interface SubtractionUi {
    /**
     * 
     * @type {number}
     * @memberof SubtractionUi
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof SubtractionUi
     */
    subtractionValue: number;
    /**
     * 
     * @type {SubtractionType}
     * @memberof SubtractionUi
     */
    subtractionType: SubtractionType;
}



/**
 * 
 * @export
 */
export const SupportedTimezone = {
    EuropeLondon: 'EUROPE_LONDON'
} as const;
export type SupportedTimezone = typeof SupportedTimezone[keyof typeof SupportedTimezone];

/**
 * 
 * @export
 * @interface TmcAutotraderVehicleDataConfigurationDTO
 */
export interface TmcAutotraderVehicleDataConfigurationDTO extends VehicleDataConfigurationDTO {
    /**
     * 
     * @type {string}
     * @memberof TmcAutotraderVehicleDataConfigurationDTO
     */
    advertiserId: string;
}


/**
 * 
 * @export
 * @interface ToolSettingsDTO
 */
export interface ToolSettingsDTO {
    /**
     * 
     * @type {number}
     * @memberof ToolSettingsDTO
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ToolSettingsDTO
     */
    testDriveBookingEnabled?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateBotRequest
 */
export interface UpdateBotRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    publicId: string;
    /**
     * 
     * @type {BotType}
     * @memberof UpdateBotRequest
     */
    botType: BotType;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBotRequest
     */
    isReimportFinished?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    siteName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    siteURL: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    conversationLimit: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    workingRange?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    lastRenewalDate: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    knowledge: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    teamInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    openAiApiKey?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    emailConfigurationId: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    assistantEmail: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    assistantEmailPassword: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateBotRequest
     */
    emailTranscriptRecipients: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBotRequest
     */
    filtrationEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    financeConfigurationId?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    financeIddUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    financeInterestRate?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateBotRequest
     */
    publicLocationIdList: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    valuationConfigurationId: number;
    /**
     * 
     * @type {Array<UpdateRetailPriceRuleRequest>}
     * @memberof UpdateBotRequest
     */
    retailPriceRules: Array<UpdateRetailPriceRuleRequest>;
    /**
     * 
     * @type {UpdateConditionMultipliersRequest}
     * @memberof UpdateBotRequest
     */
    conditionMultipliers: UpdateConditionMultipliersRequest;
    /**
     * 
     * @type {UpdateServiceHistoryMultipliersRequest}
     * @memberof UpdateBotRequest
     */
    serviceHistoryMultipliers: UpdateServiceHistoryMultipliersRequest;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    minDeduction: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    maxDeduction: number;
    /**
     * 
     * @type {RedirectProvider}
     * @memberof UpdateBotRequest
     */
    redirectProvider: RedirectProvider;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    urlProcessorConfigurationId: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBotRequest
     */
    urlProcessorEnabled: boolean;
    /**
     * 
     * @type {MatchField}
     * @memberof UpdateBotRequest
     */
    matchField?: MatchField;
    /**
     * 
     * @type {MatchType}
     * @memberof UpdateBotRequest
     */
    matchType?: MatchType;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    segmentNumberFromTheEnd?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    toolSettingsId: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBotRequest
     */
    testDriveBookingEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    reservationConfigurationId: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    stripePublicKey?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    stripeSecretKey?: string;
    /**
     * 
     * @type {Currency}
     * @memberof UpdateBotRequest
     */
    currency?: Currency;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    timezone?: UpdateBotRequestTimezoneEnum;
}


/**
 * @export
 */
export const UpdateBotRequestTimezoneEnum = {
    EuropeLondon: 'EUROPE_LONDON'
} as const;
export type UpdateBotRequestTimezoneEnum = typeof UpdateBotRequestTimezoneEnum[keyof typeof UpdateBotRequestTimezoneEnum];

/**
 * 
 * @export
 * @interface UpdateConditionMultipliersRequest
 */
export interface UpdateConditionMultipliersRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateConditionMultipliersRequest
     */
    id?: number;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateConditionMultipliersRequest
     */
    excellentSubtraction: UpdateSubtractionRequest;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateConditionMultipliersRequest
     */
    goodSubtraction: UpdateSubtractionRequest;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateConditionMultipliersRequest
     */
    averageSubtraction: UpdateSubtractionRequest;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateConditionMultipliersRequest
     */
    belowAverageSubtraction: UpdateSubtractionRequest;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateConditionMultipliersRequest
     */
    poorSubtraction: UpdateSubtractionRequest;
}
/**
 * 
 * @export
 * @interface UpdateLocationRequest
 */
export interface UpdateLocationRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    postcode: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    phoneNumber: string;
    /**
     * 
     * @type {UpdateWorkScheduleRequest}
     * @memberof UpdateLocationRequest
     */
    workSchedule: UpdateWorkScheduleRequest;
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationRequest
     */
    vehicleDataConfigurationId: number;
    /**
     * 
     * @type {VehicleDataProvider}
     * @memberof UpdateLocationRequest
     */
    vehicleDataProvider: VehicleDataProvider;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    advertiserId?: string;
}


/**
 * 
 * @export
 * @interface UpdateRetailPriceRuleRequest
 */
export interface UpdateRetailPriceRuleRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateRetailPriceRuleRequest
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateRetailPriceRuleRequest
     */
    min: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateRetailPriceRuleRequest
     */
    max: number;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateRetailPriceRuleRequest
     */
    subtraction: UpdateSubtractionRequest;
}
/**
 * 
 * @export
 * @interface UpdateServiceHistoryMultipliersRequest
 */
export interface UpdateServiceHistoryMultipliersRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateServiceHistoryMultipliersRequest
     */
    id?: number;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateServiceHistoryMultipliersRequest
     */
    fullHistorySubtraction: UpdateSubtractionRequest;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateServiceHistoryMultipliersRequest
     */
    partHistorySubtraction: UpdateSubtractionRequest;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateServiceHistoryMultipliersRequest
     */
    noHistorySubtraction: UpdateSubtractionRequest;
}
/**
 * 
 * @export
 * @interface UpdateSubtractionRequest
 */
export interface UpdateSubtractionRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateSubtractionRequest
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSubtractionRequest
     */
    subtractionValue: number;
    /**
     * 
     * @type {SubtractionType}
     * @memberof UpdateSubtractionRequest
     */
    subtractionType: SubtractionType;
}


/**
 * 
 * @export
 * @interface UpdateVehicleDetailsButtonRequest
 */
export interface UpdateVehicleDetailsButtonRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateVehicleDetailsButtonRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDetailsButtonRequest
     */
    buttonText: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDetailsButtonRequest
     */
    message?: string;
    /**
     * 
     * @type {ClickAction}
     * @memberof UpdateVehicleDetailsButtonRequest
     */
    clickAction: ClickAction;
}


/**
 * 
 * @export
 * @interface UpdateWidgetAppearanceSettingsRequest
 */
export interface UpdateWidgetAppearanceSettingsRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateWidgetAppearanceSettingsRequest
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateWidgetAppearanceSettingsRequest
     */
    publicBotId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWidgetAppearanceSettingsRequest
     */
    mainColour: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWidgetAppearanceSettingsRequest
     */
    buttonColour: string;
    /**
     * 
     * @type {WidgetPosition}
     * @memberof UpdateWidgetAppearanceSettingsRequest
     */
    widgetPosition: WidgetPosition;
    /**
     * 
     * @type {number}
     * @memberof UpdateWidgetAppearanceSettingsRequest
     */
    horizontalOffsetPx: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateWidgetAppearanceSettingsRequest
     */
    verticalOffsetPx: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWidgetAppearanceSettingsRequest
     */
    hidePoweredBy: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWidgetAppearanceSettingsRequest
     */
    promptPopUpView: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateWidgetAppearanceSettingsRequest
     */
    initialBotMessage: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWidgetAppearanceSettingsRequest
     */
    defaultPopUpMessage?: string;
    /**
     * 
     * @type {Array<UpdateWidgetConvoStartersRequest>}
     * @memberof UpdateWidgetAppearanceSettingsRequest
     */
    convoStarters?: Array<UpdateWidgetConvoStartersRequest>;
    /**
     * 
     * @type {Array<UpdateVehicleDetailsButtonRequest>}
     * @memberof UpdateWidgetAppearanceSettingsRequest
     */
    vehicleDetailsButtons?: Array<UpdateVehicleDetailsButtonRequest>;
}


/**
 * 
 * @export
 * @interface UpdateWidgetConvoStartersRequest
 */
export interface UpdateWidgetConvoStartersRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateWidgetConvoStartersRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateWidgetConvoStartersRequest
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWidgetConvoStartersRequest
     */
    visibility: string;
}
/**
 * 
 * @export
 * @interface UpdateWorkScheduleRequest
 */
export interface UpdateWorkScheduleRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkScheduleRequest
     */
    id?: number;
    /**
     * 
     * @type {UpdateWorkingHoursRequest}
     * @memberof UpdateWorkScheduleRequest
     */
    monday: UpdateWorkingHoursRequest;
    /**
     * 
     * @type {UpdateWorkingHoursRequest}
     * @memberof UpdateWorkScheduleRequest
     */
    tuesday: UpdateWorkingHoursRequest;
    /**
     * 
     * @type {UpdateWorkingHoursRequest}
     * @memberof UpdateWorkScheduleRequest
     */
    wednesday: UpdateWorkingHoursRequest;
    /**
     * 
     * @type {UpdateWorkingHoursRequest}
     * @memberof UpdateWorkScheduleRequest
     */
    thursday: UpdateWorkingHoursRequest;
    /**
     * 
     * @type {UpdateWorkingHoursRequest}
     * @memberof UpdateWorkScheduleRequest
     */
    friday: UpdateWorkingHoursRequest;
    /**
     * 
     * @type {UpdateWorkingHoursRequest}
     * @memberof UpdateWorkScheduleRequest
     */
    saturday: UpdateWorkingHoursRequest;
    /**
     * 
     * @type {UpdateWorkingHoursRequest}
     * @memberof UpdateWorkScheduleRequest
     */
    sunday: UpdateWorkingHoursRequest;
}
/**
 * 
 * @export
 * @interface UpdateWorkingHoursRequest
 */
export interface UpdateWorkingHoursRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkingHoursRequest
     */
    id?: number;
    /**
     * 
     * @type {LocalTime}
     * @memberof UpdateWorkingHoursRequest
     */
    openTime?: LocalTime;
    /**
     * 
     * @type {LocalTime}
     * @memberof UpdateWorkingHoursRequest
     */
    closeTime?: LocalTime;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWorkingHoursRequest
     */
    isClosed: boolean;
}
/**
 * 
 * @export
 * @interface UrlProcessorConfigurationDTO
 */
export interface UrlProcessorConfigurationDTO {
    /**
     * 
     * @type {number}
     * @memberof UrlProcessorConfigurationDTO
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UrlProcessorConfigurationDTO
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UrlProcessorConfigurationDTO
     */
    matchField?: UrlProcessorConfigurationDTOMatchFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof UrlProcessorConfigurationDTO
     */
    matchType?: UrlProcessorConfigurationDTOMatchTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UrlProcessorConfigurationDTO
     */
    segmentNumberFromTheEnd?: number;
}


/**
 * @export
 */
export const UrlProcessorConfigurationDTOMatchFieldEnum = {
    ExternalStockId: 'EXTERNAL_STOCK_ID',
    Derivative: 'DERIVATIVE'
} as const;
export type UrlProcessorConfigurationDTOMatchFieldEnum = typeof UrlProcessorConfigurationDTOMatchFieldEnum[keyof typeof UrlProcessorConfigurationDTOMatchFieldEnum];

/**
 * @export
 */
export const UrlProcessorConfigurationDTOMatchTypeEnum = {
    ExactMatch: 'EXACT_MATCH',
    FuzzyMatch: 'FUZZY_MATCH'
} as const;
export type UrlProcessorConfigurationDTOMatchTypeEnum = typeof UrlProcessorConfigurationDTOMatchTypeEnum[keyof typeof UrlProcessorConfigurationDTOMatchTypeEnum];

/**
 * 
 * @export
 * @interface ValuationConfigurationDTO
 */
export interface ValuationConfigurationDTO {
    /**
     * 
     * @type {number}
     * @memberof ValuationConfigurationDTO
     */
    id?: number;
    /**
     * 
     * @type {Array<RetailPriceRuleDTO>}
     * @memberof ValuationConfigurationDTO
     */
    retailPriceRules?: Array<RetailPriceRuleDTO>;
    /**
     * 
     * @type {ConditionMultipliersDTO}
     * @memberof ValuationConfigurationDTO
     */
    conditionMultipliers?: ConditionMultipliersDTO;
    /**
     * 
     * @type {ServiceHistoryMultipliersDTO}
     * @memberof ValuationConfigurationDTO
     */
    serviceHistoryMultipliers?: ServiceHistoryMultipliersDTO;
    /**
     * 
     * @type {number}
     * @memberof ValuationConfigurationDTO
     */
    minDeduction?: number;
    /**
     * 
     * @type {number}
     * @memberof ValuationConfigurationDTO
     */
    maxDeduction?: number;
}
/**
 * 
 * @export
 * @interface VehicleDataConfigurationDTO
 */
export interface VehicleDataConfigurationDTO {
    /**
     * 
     * @type {number}
     * @memberof VehicleDataConfigurationDTO
     */
    id?: number;
    /**
     * 
     * @type {VehicleDataProvider}
     * @memberof VehicleDataConfigurationDTO
     */
    vehicleDataProvider: VehicleDataProvider;
}


/**
 * 
 * @export
 * @interface VehicleDataDTO
 */
export interface VehicleDataDTO {
    /**
     * 
     * @type {number}
     * @memberof VehicleDataDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    vin: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    registration: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    make: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    derivative: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleDataDTO
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDataDTO
     */
    mileage?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    location_city: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleDataDTO
     */
    image_list: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    redirect_url?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    vat_status?: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleDataDTO
     */
    year_of_manufacture?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    fuel_type?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    transmission_type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDataDTO
     */
    is_vat_included?: boolean;
}

/**
 * 
 * @export
 */
export const VehicleDataProvider = {
    NoProvider: 'NO_PROVIDER',
    Autotrader: 'AUTOTRADER',
    TmcAutotrader: 'TMC_AUTOTRADER',
    Cazoo: 'CAZOO'
} as const;
export type VehicleDataProvider = typeof VehicleDataProvider[keyof typeof VehicleDataProvider];

/**
 * 
 * @export
 * @interface VehicleDetailsButtonDTO
 */
export interface VehicleDetailsButtonDTO {
    /**
     * 
     * @type {number}
     * @memberof VehicleDetailsButtonDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDetailsButtonDTO
     */
    buttonText?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDetailsButtonDTO
     */
    message?: string;
    /**
     * 
     * @type {ClickAction}
     * @memberof VehicleDetailsButtonDTO
     */
    clickAction?: ClickAction;
}


/**
 * 
 * @export
 * @interface VehicleDetailsButtonUi
 */
export interface VehicleDetailsButtonUi {
    /**
     * 
     * @type {number}
     * @memberof VehicleDetailsButtonUi
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDetailsButtonUi
     */
    buttonText: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDetailsButtonUi
     */
    message?: string;
    /**
     * 
     * @type {ClickAction}
     * @memberof VehicleDetailsButtonUi
     */
    clickAction: ClickAction;
}


/**
 * 
 * @export
 * @interface VehicleDetailsCardDTO
 */
export interface VehicleDetailsCardDTO {
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof VehicleDetailsCardDTO
     */
    sections?: { [key: string]: object; };
}
/**
 * 
 * @export
 * @interface WidgetAppearanceConfigDTO
 */
export interface WidgetAppearanceConfigDTO {
    /**
     * 
     * @type {string}
     * @memberof WidgetAppearanceConfigDTO
     */
    mainColour: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppearanceConfigDTO
     */
    buttonColour: string;
    /**
     * 
     * @type {WidgetPosition}
     * @memberof WidgetAppearanceConfigDTO
     */
    widgetPosition: WidgetPosition;
    /**
     * 
     * @type {number}
     * @memberof WidgetAppearanceConfigDTO
     */
    horizontalOffsetPx: number;
    /**
     * 
     * @type {number}
     * @memberof WidgetAppearanceConfigDTO
     */
    verticalOffsetPx: number;
    /**
     * 
     * @type {boolean}
     * @memberof WidgetAppearanceConfigDTO
     */
    hidePoweredBy: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WidgetAppearanceConfigDTO
     */
    promptPopUpView: boolean;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppearanceConfigDTO
     */
    defaultPopUpMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppearanceConfigDTO
     */
    initialBotMessage: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WidgetAppearanceConfigDTO
     */
    bubbleConvoStarters?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WidgetAppearanceConfigDTO
     */
    chatConvoStarters?: Array<string>;
    /**
     * 
     * @type {Array<VehicleDetailsButtonDTO>}
     * @memberof WidgetAppearanceConfigDTO
     */
    vehicleDetailsButtons?: Array<VehicleDetailsButtonDTO>;
}


/**
 * 
 * @export
 * @interface WidgetChatMessage
 */
export interface WidgetChatMessage {
    /**
     * 
     * @type {MessageType}
     * @memberof WidgetChatMessage
     */
    type: MessageType;
    /**
     * 
     * @type {MessageRole}
     * @memberof WidgetChatMessage
     */
    role: MessageRole;
    /**
     * 
     * @type {string}
     * @memberof WidgetChatMessage
     */
    message?: string;
    /**
     * 
     * @type {Array<VehicleDataDTO>}
     * @memberof WidgetChatMessage
     */
    vehicleDataList?: Array<VehicleDataDTO>;
    /**
     * 
     * @type {string}
     * @memberof WidgetChatMessage
     */
    videoUrl?: string;
    /**
     * 
     * @type {StripeMessageStatus}
     * @memberof WidgetChatMessage
     */
    stripeMessageStatus?: StripeMessageStatus;
    /**
     * 
     * @type {number}
     * @memberof WidgetChatMessage
     */
    stripePaymentId?: number;
    /**
     * 
     * @type {string}
     * @memberof WidgetChatMessage
     */
    timestamp: string;
}


/**
 * 
 * @export
 * @interface WidgetChatRequest
 */
export interface WidgetChatRequest {
    /**
     * 
     * @type {string}
     * @memberof WidgetChatRequest
     */
    publicBotId: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetChatRequest
     */
    chatId: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetChatRequest
     */
    message: string;
    /**
     * 
     * @type {InitializationType}
     * @memberof WidgetChatRequest
     */
    initializationType: InitializationType;
    /**
     * 
     * @type {InputType}
     * @memberof WidgetChatRequest
     */
    inputType: InputType;
    /**
     * 
     * @type {string}
     * @memberof WidgetChatRequest
     */
    pageFullUrl: string;
    /**
     * 
     * @type {FocusedVehicle}
     * @memberof WidgetChatRequest
     */
    focusedVehicle?: FocusedVehicle;
}


/**
 * 
 * @export
 * @interface WidgetChatResponse
 */
export interface WidgetChatResponse {
    /**
     * 
     * @type {Array<WidgetChatMessage>}
     * @memberof WidgetChatResponse
     */
    widgetChatMessages: Array<WidgetChatMessage>;
    /**
     * 
     * @type {Array<WidgetChatResponseWidgetChatEventsInner>}
     * @memberof WidgetChatResponse
     */
    widgetChatEvents?: Array<WidgetChatResponseWidgetChatEventsInner>;
}
/**
 * @type WidgetChatResponseWidgetChatEventsInner
 * 
 * @export
 */
export type WidgetChatResponseWidgetChatEventsInner = BookedCallBackChatEventDTO | BookedEmailFollowUpChatEventDTO | BookedTestDriveChatEventDTO | CheckedCallBackBookingAvailabilityChatEventDTO | CheckedTestDriveBookingAvailabilityChatEventDTO | RequestedLimitedFinanceIllustrationChatEventDTO | RequestedLimitedVehicleInformationChatEventDTO | RequestedLimitedVehicleReservationChatEventDTO | RequestedLimitedVehicleValuationChatEventDTO | ReservedVehicleChatEventDTO | ReturnedCompanyInformationChatEventDTO | ReturnedCompanyWorkingHoursChatEventDTO | ReturnedFinanceApplicationChatEventDTO | ReturnedFinanceIllustrationChatEventDTO | ReturnedFinanceQuoteChatEventDTO | ReturnedJourneyDetailsChatEventDTO | ReturnedLocationInformationChatEventDTO | ReturnedStripeFormChatEventDTO | ReturnedVehicleInformationChatEventDTO | ReturnedVehicleValuationChatEventDTO;

/**
 * 
 * @export
 */
export const WidgetPosition = {
    Left: 'BOTTOM_LEFT',
    Right: 'BOTTOM_RIGHT'
} as const;
export type WidgetPosition = typeof WidgetPosition[keyof typeof WidgetPosition];

/**
 * 
 * @export
 * @interface WidgetSettings
 */
export interface WidgetSettings {
    /**
     * 
     * @type {string}
     * @memberof WidgetSettings
     */
    name: string;
    /**
     * 
     * @type {BotType}
     * @memberof WidgetSettings
     */
    botType: BotType;
    /**
     * 
     * @type {boolean}
     * @memberof WidgetSettings
     */
    showWidget: boolean;
    /**
     * 
     * @type {string}
     * @memberof WidgetSettings
     */
    stripePublicKey?: string;
    /**
     * 
     * @type {number}
     * @memberof WidgetSettings
     */
    reservationPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof WidgetSettings
     */
    reservationCurrency?: WidgetSettingsReservationCurrencyEnum;
    /**
     * 
     * @type {WidgetAppearanceConfigDTO}
     * @memberof WidgetSettings
     */
    widgetAppearanceSetting: WidgetAppearanceConfigDTO;
}


/**
 * @export
 */
export const WidgetSettingsReservationCurrencyEnum = {
    Pound: 'POUND'
} as const;
export type WidgetSettingsReservationCurrencyEnum = typeof WidgetSettingsReservationCurrencyEnum[keyof typeof WidgetSettingsReservationCurrencyEnum];

/**
 * 
 * @export
 * @interface WidgetUserInitializationResponse
 */
export interface WidgetUserInitializationResponse {
    /**
     * 
     * @type {string}
     * @memberof WidgetUserInitializationResponse
     */
    chatId: string;
}
/**
 * 
 * @export
 * @interface WorkScheduleDTO
 */
export interface WorkScheduleDTO {
    /**
     * 
     * @type {number}
     * @memberof WorkScheduleDTO
     */
    id?: number;
    /**
     * 
     * @type {WorkingHoursDTO}
     * @memberof WorkScheduleDTO
     */
    monday?: WorkingHoursDTO;
    /**
     * 
     * @type {WorkingHoursDTO}
     * @memberof WorkScheduleDTO
     */
    tuesday?: WorkingHoursDTO;
    /**
     * 
     * @type {WorkingHoursDTO}
     * @memberof WorkScheduleDTO
     */
    wednesday?: WorkingHoursDTO;
    /**
     * 
     * @type {WorkingHoursDTO}
     * @memberof WorkScheduleDTO
     */
    thursday?: WorkingHoursDTO;
    /**
     * 
     * @type {WorkingHoursDTO}
     * @memberof WorkScheduleDTO
     */
    friday?: WorkingHoursDTO;
    /**
     * 
     * @type {WorkingHoursDTO}
     * @memberof WorkScheduleDTO
     */
    saturday?: WorkingHoursDTO;
    /**
     * 
     * @type {WorkingHoursDTO}
     * @memberof WorkScheduleDTO
     */
    sunday?: WorkingHoursDTO;
}
/**
 * 
 * @export
 * @interface WorkScheduleUi
 */
export interface WorkScheduleUi {
    /**
     * 
     * @type {number}
     * @memberof WorkScheduleUi
     */
    id: number;
    /**
     * 
     * @type {WorkingHoursUi}
     * @memberof WorkScheduleUi
     */
    monday: WorkingHoursUi;
    /**
     * 
     * @type {WorkingHoursUi}
     * @memberof WorkScheduleUi
     */
    tuesday: WorkingHoursUi;
    /**
     * 
     * @type {WorkingHoursUi}
     * @memberof WorkScheduleUi
     */
    wednesday: WorkingHoursUi;
    /**
     * 
     * @type {WorkingHoursUi}
     * @memberof WorkScheduleUi
     */
    thursday: WorkingHoursUi;
    /**
     * 
     * @type {WorkingHoursUi}
     * @memberof WorkScheduleUi
     */
    friday: WorkingHoursUi;
    /**
     * 
     * @type {WorkingHoursUi}
     * @memberof WorkScheduleUi
     */
    saturday: WorkingHoursUi;
    /**
     * 
     * @type {WorkingHoursUi}
     * @memberof WorkScheduleUi
     */
    sunday: WorkingHoursUi;
}
/**
 * 
 * @export
 * @interface WorkingHoursDTO
 */
export interface WorkingHoursDTO {
    /**
     * 
     * @type {number}
     * @memberof WorkingHoursDTO
     */
    id?: number;
    /**
     * 
     * @type {LocalTime}
     * @memberof WorkingHoursDTO
     */
    openTime?: LocalTime;
    /**
     * 
     * @type {LocalTime}
     * @memberof WorkingHoursDTO
     */
    closeTime?: LocalTime;
    /**
     * 
     * @type {boolean}
     * @memberof WorkingHoursDTO
     */
    isClosed?: boolean;
}
/**
 * 
 * @export
 * @interface WorkingHoursUi
 */
export interface WorkingHoursUi {
    /**
     * 
     * @type {number}
     * @memberof WorkingHoursUi
     */
    id: number;
    /**
     * 
     * @type {LocalTime}
     * @memberof WorkingHoursUi
     */
    openTime: LocalTime;
    /**
     * 
     * @type {LocalTime}
     * @memberof WorkingHoursUi
     */
    closeTime: LocalTime;
    /**
     * 
     * @type {boolean}
     * @memberof WorkingHoursUi
     */
    isClosed: boolean;
}
